module.exports = __webpack_public_path__ + "img/a118b68.png";